export enum CatalogueAnimalError {
  InvalidTemplate = 200,
  EmptyFile = 201,
  InvalidAnimalFormat = 202,
  InvalidLotNumber = 203,
  AnimalNotFound = 204,
  /**
   * The animal is already in an existing catalogue.
   */
  AnimalInExistingCatalogue = 206,
}
